var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mustShowInputComponent || _vm.isMobile,
            expression: "mustShowInputComponent || isMobile",
          },
        ],
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.passeioTipo !== "intervalo_dias",
                expression: "passeioTipo !== 'intervalo_dias'",
              },
            ],
          },
          [
            !_vm.isMobile
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "14px",
                      "margin-bottom": "10px",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa-regular fa-clock" }),
                    _vm._v("  \n        "),
                    _c("strong", [_vm._v(_vm._s(_vm.titulo))]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.horarios.length > 0
              ? _c(
                  "div",
                  {
                    class: {
                      "container-horarios": !_vm.isMobile,
                      "container-horarios-mobile": _vm.isMobile,
                    },
                  },
                  _vm._l(_vm.horarios, function (hora) {
                    return _c(
                      "div",
                      { key: hora.id, staticClass: "item-container" },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              item: true,
                              "item-disabled":
                                _vm.getQuantidadeVagas(hora) <= 0 ||
                                _vm.getQuantidadeVagasDisponiveis(hora) < 0,
                            },
                            style: {
                              "background-color":
                                hora.id === _vm.value
                                  ? _vm.primaryColor
                                  : "white",
                              color:
                                hora.id === _vm.value ? "white" : "#2A2A2A",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectHora(hora.id)
                              },
                            },
                          },
                          [
                            _vm.isMobile
                              ? _c("strong", [_vm._v(_vm._s(hora.label))])
                              : _c("span", [_vm._v(_vm._s(hora.label))]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showRemainingVacancies
                          ? _c("div", [
                              _vm.getQuantidadeVagas(hora) == 1
                                ? _c(
                                    "small",
                                    {
                                      style: {
                                        color: _vm.getCorQuantidade(hora),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Resta " +
                                          _vm._s(_vm.getQuantidadeVagas(hora)) +
                                          " vaga"
                                      ),
                                    ]
                                  )
                                : _vm.getQuantidadeVagas(hora) > 0
                                ? _c(
                                    "small",
                                    {
                                      style: {
                                        color: _vm.getCorQuantidade(hora),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Restam " +
                                          _vm._s(_vm.getQuantidadeVagas(hora)) +
                                          " vagas"
                                      ),
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      style: {
                                        color: _vm.getCorQuantidade(hora),
                                      },
                                    },
                                    [_vm._v("Esgotado")]
                                  ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticStyle: { "text-align": "center" } }, [
                  _c("i", [_vm._v("Nenhuma horário disponível")]),
                ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.passeioTipo === "intervalo_dias" && _vm.isMobile,
                expression: "passeioTipo === 'intervalo_dias' && isMobile",
              },
            ],
            staticStyle: { "text-align": "center" },
          },
          [_c("i", [_vm._v("Atividade para o dia todo")])]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }